import Vue from 'vue'

const state = {
  globalInfo: {}
}

const getters = {
  currentInfo: state => state.globalInfo
}

const actions = {
  async fetchGlobalInfo ({ commit }) {
    await Vue.axios.get('/api/system/info').then(res => {
      if (res.status === 200) commit('setGlobalInfo', res.data.info)
    }).catch(e => {
      commit('resetGlobalInfo')
    })
  },

  async updateGlobalInfo ({ commit, dispatch }, val) {
    const res = await Vue.axios.post('/api/system/info', { info: val.text })
    if (res.status === 200) await dispatch('fetchGlobalInfo')
  }
}

const mutations = {
  setGlobalInfo (state, info) {
    state.globalInfo = info
  },
  setGlobalInfoTest (state, info) {
    state.globalInfo = info
  },
  resetGlobalInfo (state) {
    state.globalInfo = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/globalInfo.js